export function saveMerchantBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  try {
    link.href = url;
    link.download = filename;
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
  } finally {
    link.remove();
    URL.revokeObjectURL(url);
  }
}

export function merchantReceiptFilename(
  orderId: string,
  blob: Blob,
): string {
  const extension = blob.type === "application/zip" ? "zip" : "pdf";
  return `order-${orderId}-receipts.${extension}`;
}
